import { Box, Title } from '@factorialco/deprecated-design-system'

import { useAsyncData } from 'modules/core/hooks/useAsyncData'
import i18n from 'modules/core/lib/i18n'
import companies from 'modules/core/store/collections/companies'
import legalEntities from 'modules/core/store/collections/legalEntities'

import taxonomies from 'modules/contracts/store/collections/taxonomies'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import locations from 'modules/locations/store/collections/locations'
import { useHasCompensations } from 'modules/payroll_bundle/hooks/useHasCompensations'
import PayrollPaywallGuard from 'modules/payroll_bundle/pages/PayrollPaywallGuard'
import EmployeesData from 'modules/payroll_integrations/components/Content/EmployeeData'
import Table from 'modules/payroll_integrations/components/Table'
import PayrollIntegration from 'modules/payroll_integrations/lib/catalog'
import type { Codeable, ColumnNames } from 'modules/payroll_integrations/lib/types'
import leaveTypes from 'modules/timeoff/store/collections/leaveTypes'

const YeapPaierhIntegration = () => {
  const INTEGRATION_NAME = PayrollIntegration.yeapPaierh
  const { hasCompensations, loading, error } = useHasCompensations()

  const COLUMN_NAMES: ColumnNames = [
    {
      name: i18n.t(
        'app_store_v2.app_integrations.payroll_integrations_yeap_paierh.settings.form.header.concept'
      ),
      colSpan: 4,
      attribute: 'concept',
    },
    {
      name: i18n.t(
        'app_store_v2.app_integrations.payroll_integrations_yeap_paierh.settings.form.header.value'
      ),
      colSpan: 4,
      attribute: 'value',
    },
  ]

  const { loading: loadingCollections } = useAsyncData(() => {
    return Promise.all([taxonomies.fetch(), leaveTypes.fetch(), legalEntities.fetch()])
  }, [])

  const codeables: Record<string, Codeable> = {
    sirenNumber: {
      position: 1,
      collection: [companies.current],
      class: 'SirenNumber',
      label: i18n.t(
        'app_store_v2.app_integrations.payroll_integrations_yeap_paierh.settings.form.concept.siren_number'
      ),
    },
    legalEntity: {
      position: 2,
      collection: legalEntities,
      class: 'LegalEntity',
      label: i18n.t(
        'app_store_v2.app_integrations.payroll_integrations_yeap_paierh.settings.form.concept.legal_entity'
      ),
    },
    location: {
      position: 3,
      collection: locations,
      class: 'Location',
      label: i18n.t(
        'app_store_v2.app_integrations.payroll_integrations_yeap_paierh.settings.form.concept.location'
      ),
    },

    leave_type: {
      position: 5,
      collection: leaveTypes.filter((lt) => lt.isActive),
      class: 'Timeoff::LeaveType',
      label: i18n.t(
        'app_store_v2.app_integrations.payroll_integrations_yeap_paierh.settings.form.concept.leave_type'
      ),
    },
    leave_type_forfait_jours: {
      position: 6,
      collection: leaveTypes.filter((lt) => lt.isActive),
      class: 'Timeoff::LeaveType',
      forfait_jours: true,
      label: i18n.t(
        'app_store_v2.app_integrations.payroll_integrations_yeap_paierh.settings.form.concept.leave_type_forfait_jours'
      ),
    },
  }

  if (!hasCompensations) {
    codeables.taxonomy = {
      position: 4,
      collection: taxonomies.actives,
      class: 'Contracts::Compensations::Taxonomy',
      label: i18n.t(
        'app_store_v2.app_integrations.payroll_integrations_yeap_paierh.settings.form.concept.taxonomy'
      ),
    }
  }

  return (
    <PayrollPaywallGuard>
      <ResponsivePage.Body
        variant="full"
        showHeader={false}
        loading={loading || loadingCollections}
        error={error}
      >
        <Box alignItems="center" gap="s32" paddingY="s48" paddingX="s64">
          <Title
            variant="400"
            description={i18n.t(
              'app_store_v2.app_integrations.payroll_integrations_yeap_paierh.general.description'
            )}
            illustration="smart-document"
            centered
            title={i18n.t(
              'app_store_v2.app_integrations.payroll_integrations_yeap_paierh.general.title'
            )}
          />
        </Box>
        <Box>
          <Box width="full">
            <Table
              columnNames={COLUMN_NAMES}
              codeables={codeables}
              integration={INTEGRATION_NAME}
            />
          </Box>
          <EmployeesData
            integration_name={i18n.t(
              'app_store_v2.app_integrations.payroll_integrations_yeap_paierh.integration_name'
            )}
          />
        </Box>
      </ResponsivePage.Body>
    </PayrollPaywallGuard>
  )
}

export default YeapPaierhIntegration
